<lib-page-container title="Search advertisers" [subtitle]="grid.total > 0 ? (grid.total + ' items') : ''"
  [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button (click)="filters.open()" tooltip="Search" icon="search">Search</lib-button>
    <lib-button
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_CREATE]"
      (click)="add()" tooltip="Add advertiser" icon="add">Add advertiser</lib-button>
  </div>
  <div lib-page-body>
    <app-advertiser-grid #grid></app-advertiser-grid>
    <app-advertiser-filters #filters (search)="onSearch($event)"></app-advertiser-filters>
  </div>
</lib-page-container>